import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import * as Loading from "@repoflow/components/loading";
import { GET } from "queries/account";
import { useQuery } from "@apollo/client";
import * as LocalStorageLib from "@repoflow/browser/local-storage";
import { basename } from "env"
export const Context = React.createContext(null);


export const useAccount = () => {
  return useContext(Context);
};

const readAccount = () => {
  const accountStr = LocalStorageLib.getWithExpiry("account");
  if (!accountStr) {
    return null;
  }
  return JSON.parse(accountStr);
};

export const writeAccount = (account) => LocalStorageLib.setWithExpiry("account", JSON.stringify(account), 15 * 60000)
export const resetAccount = () => LocalStorageLib.removeWithExpiry("account");

export const Provider = ({ children }) => {
  const [account, setAccountState] = useState(() => {
    const val = readAccount()
    return val
  });
  const { loading, error, data, refetch } = useQuery(GET, { skip: account !== null, fetchPolicy: "network-only" });


  useEffect(() => {
    function checkUserData() {
      setAccountState(readAccount());
    }

    window.addEventListener("storage", checkUserData);
    return () => {
      window.removeEventListener("storage", checkUserData);
    };
  }, []);

  useEffect(() => {
    if (!account) {
      refetch()
    }
  }, [account])

  useEffect(() => {
    if (data) {
      const account = data.viewer.account;

      if (account) {
        writeAccount(account);
      }else{
        resetAccount()
      }
    } else {
      
    }
  }, [data]);

  if (loading)
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  if (error) return `Error! ${error.message}`;

  return <Context.Provider value={account || data?.viewer?.account}>{children}</Context.Provider>;
};
